export default __webpack_public_path__ + "static/media/travelIns.f1db8e42.jpg";